import { Auth0Provider } from '@auth0/auth0-react';
import { BlankScreen } from '@strata/react-page-templates';
import { type ReactElement } from 'react';

import { useAuth0Info } from 'services/environment';
import { AppRoutes } from 'services/routes';

interface AuthProviderProps {
    children: ReactElement;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
    const AUTH0_INFO = useAuth0Info();
    return !AUTH0_INFO?.clientId ? (
        <BlankScreen />
    ) : (
        <Auth0Provider
            domain={AUTH0_INFO.domain}
            clientId={AUTH0_INFO.clientId}
            authorizationParams={{
                audience: AUTH0_INFO.audience,
                redirect_uri: `${window.location.origin}${AppRoutes.callback}`,
            }}
        >
            {children}
        </Auth0Provider>
    );
};
